module.exports = __webpack_public_path__ + "static/media/a1.90cb3e32.jpg";